var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"summary text-center"},[_c('h1',[_vm._v(_vm._s(_vm.headline))]),_vm._t("default",function(){return [_vm._v(" This will only be displayed if there is no content to be distributed. ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }